module.exports = __webpack_public_path__ + "img/platformmembercenter.9acf6a7f.jpg";